const fetchUsersData = async () => {
    try {

        const response = await fetch(`${process.env.REACT_APP_PHPSC_BACK_URL}/phpsc-backend/api/v1/users`, {
            method: 'GET',
            credentials: 'include' // Include cookies
        });

        if (!response.ok) {
            // Check if the status code is 401
           if ( response.status === 403) {
                          console.warn('🔒 Token expired or unauthorized. Logging out...');

                          document.cookie = 'auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';

                          // Optional: clear localStorage if needed
                          localStorage.removeItem('redirectURL');

                          // Force a full reload or redirect to login
                          window.location.reload();
                              throw new Error(data.detail);

                      }
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching users data:', error);
        throw new Error('Failed to fetch users data');
    }
};

export default fetchUsersData;
